/**
 * `ganttSettingsFromMonday()` — read a `TimelineGanttBoardView` / `TimelineBoardView`
 * `settings_str` (`specs/M4-V3-gantt.md` §2.5, `specs/M4-V5-timeline.md` §2.2).
 *
 * Total and lossless: nothing throws on a nine-year-old row, every key monday stored is recorded
 * in `mondayKeys`, and anything this reader does not model survives in `mondayExtras` — including
 * the one row's `createdBy: 9264755`.
 */
import { columnSelectionFromMonday, singleColumnFromMonday } from '../column-selection.js';
import { extraKeys, parseViewSettingsBlob, presentKeys } from '../from-monday.js';
import { DEFAULT_GANTT_VIEW_SETTINGS, GANTT_MONDAY_KEYS } from './index.js';
export function ganttSettingsFromMonday(raw, options = {}) {
    const kind = options.kind ?? 'gantt';
    const d = options.defaults ?? DEFAULT_GANTT_VIEW_SETTINGS;
    const { object, warnings } = parseViewSettingsBlob(raw, kind);
    /**
     * An **absent** boolean is not `false`. Half the real Timeline rows carry none of the five and
     * still render weekends, a today line and a legend, so the fallback is the kind's default
     * (`true`) and `mondayKeys` is what keeps the key absent on the way back out (q424).
     */
    const bool = (key, fallback) => {
        const value = object[key];
        if (typeof value === 'boolean')
            return value;
        if (value !== undefined)
            warnings.push(`${kind}: ${key} is not a boolean`);
        return fallback;
    };
    return {
        settings: {
            dateColumns: columnSelectionFromMonday(object['columns']),
            groupBy: singleColumnFromMonday(object['group_by_id']),
            colorBy: singleColumnFromMonday(object['color_by_id']),
            labelBy: singleColumnFromMonday(object['label_by_id']),
            showTodayLine: bool('show_today_line', d.showTodayLine),
            showWeekends: bool('show_weekends', d.showWeekends),
            showRollup: bool('show_rollup', d.showRollup),
            showDependencies: bool('enable_visual_dependencies', d.showDependencies),
            displayLegend: bool('display_legend', d.displayLegend),
            zoom: d.zoom,
            collapsedGroupKeys: [],
            mondayKeys: presentKeys(object, GANTT_MONDAY_KEYS),
            mondayExtras: extraKeys(object, GANTT_MONDAY_KEYS),
        },
        warnings,
    };
}
//# sourceMappingURL=from-monday.js.map